'use client';

import React from 'react';
export { getCosImageUrl } from './url';
import { getCosImageUrl } from './url';

type CosImageProps = React.ImgHTMLAttributes<HTMLImageElement> & {
  path: string;
  /** 图片绝对质量 0-100 */
  quality?: number;
  // 保留类型兼容，优先使用 fallbackSrc
  fallbackSrc?: string | { src: string };
};

export function CosImage({
  path,
  fallbackSrc,
  quality = 100,
  alt,
  ...rest
}: CosImageProps) {
  const primarySrc = getCosImageUrl(path, quality);
  const displaySrc = fallbackSrc
    ? typeof fallbackSrc === 'string'
      ? fallbackSrc
      : fallbackSrc.src
    : primarySrc;
  return <img src={displaySrc} alt={alt ?? ''} {...rest} />;
}

